var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import 'vuetify/dist/vuetify.min.css';
import Navigation from '@/components/navigation/Navigation';
import { Component } from 'vue-property-decorator';
import { logGuard } from '@/router/helpers';
import { mixins } from 'vue-class-component';
import { SwUpdate } from '@/mixins/SwUpdate';
import SwUpdateAlert from '@/components/SwUpdateAlert/SwUpdateAlert.vue';
let App = class App extends mixins(SwUpdate) {
    constructor() {
        super(...arguments);
        this.routeName = '';
    }
    beforeCreate() {
        logGuard('[App] beforeCreate');
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        logGuard('[App] starting initialize');
    }
    get showAppLoader() {
        logGuard('[App] this.$store.state.isLoading', this.$store.state.isLoading);
        return this.$store.state.isLoading;
    }
    get dialogOptions() {
        return this.$store.state.dialog;
    }
    get isDisplayingDialog() {
        return this.dialogOptions !== null;
    }
    set isDisplayingDialog(value) {
        this.$store.dispatch('closeDialog');
    }
};
App = __decorate([
    Component({
        components: {
            Navigation,
            SwUpdateAlert,
        },
    })
], App);
export default App;
